
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {CalendarRegularRuleGetResponse} from './CalendarRegularRuleGetResponse';

/**
 * CalendarRegularRuleGetRequest struct
 */
class CalendarRegularRuleGetRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {string=} ruleName
   * @param {string=} symbol
   * @constructor
   */
  constructor (parent = new Request(), ruleName = null, symbol = null) {
    super()
    super.copy(parent)
    this.RuleName = ruleName
    this.Symbol = symbol
  }

  /**
   * Copy struct (shallow copy)
   * @this {!CalendarRegularRuleGetRequest}
   * @param {!CalendarRegularRuleGetRequest} other Other struct
   * @returns {!CalendarRegularRuleGetRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.RuleName != null) {
      this.RuleName = other.RuleName
    } else {
      this.RuleName = null
    }
    if (other.Symbol != null) {
      this.Symbol = other.Symbol
    } else {
      this.Symbol = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!CalendarRegularRuleGetRequest}
   * @returns {!CalendarRegularRuleGetRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new CalendarRegularRuleGetRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new CalendarRegularRuleGetRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!CalendarRegularRuleGetRequest}
   * @param {!CalendarRegularRuleGetRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof CalendarRegularRuleGetRequest)) {
      throw new TypeError('Instance of CalendarRegularRuleGetRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!CalendarRegularRuleGetRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      RuleName: ((this.RuleName != null) ? this.RuleName : null),
      Symbol: ((this.Symbol != null) ? this.Symbol : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return CalendarRegularRuleGetRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!CalendarRegularRuleGetRequest} other Object value
   * @returns {!CalendarRegularRuleGetRequest} Created struct
   */
  static fromObject (other) {
    return new CalendarRegularRuleGetRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!CalendarRegularRuleGetRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return CalendarRegularRuleGetRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!CalendarRegularRuleGetRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5125
  }
}

export { CalendarRegularRuleGetRequest };

/**
 * Fast Binary Encoding CalendarRegularRuleGetRequest field model
 */
class FieldModelCalendarRegularRuleGetRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.RuleName = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.Symbol = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.RuleName.fbeOffset + this.RuleName.fbeSize), buffer, this.RuleName.fbeOffset + this.RuleName.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelCalendarRegularRuleGetRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelCalendarRegularRuleGetRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelCalendarRegularRuleGetRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.RuleName.fbeSize + this.Symbol.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelCalendarRegularRuleGetRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.RuleName.fbeExtra + this.Symbol.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelCalendarRegularRuleGetRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelCalendarRegularRuleGetRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelCalendarRegularRuleGetRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5125
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelCalendarRegularRuleGetRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelCalendarRegularRuleGetRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.RuleName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RuleName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RuleName.fbeSize

    if ((fbeCurrentSize + this.Symbol.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Symbol.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Symbol.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelCalendarRegularRuleGetRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelCalendarRegularRuleGetRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelCalendarRegularRuleGetRequest}
   * @param {!CalendarRegularRuleGetRequest} fbeValue Default value, defaults is new CalendarRegularRuleGetRequest()
   * @returns {!CalendarRegularRuleGetRequest} CalendarRegularRuleGetRequest value
   */
  get (fbeValue = new CalendarRegularRuleGetRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelCalendarRegularRuleGetRequest}
   * @param {!CalendarRegularRuleGetRequest} fbeValue CalendarRegularRuleGetRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.RuleName.fbeSize) <= fbeStructSize) {
      fbeValue.RuleName = this.RuleName.get()
    } else {
      fbeValue.RuleName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RuleName.fbeSize

    if ((fbeCurrentSize + this.Symbol.fbeSize) <= fbeStructSize) {
      fbeValue.Symbol = this.Symbol.get()
    } else {
      fbeValue.Symbol = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Symbol.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelCalendarRegularRuleGetRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelCalendarRegularRuleGetRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelCalendarRegularRuleGetRequest}
   * @param {!CalendarRegularRuleGetRequest} fbeValue CalendarRegularRuleGetRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelCalendarRegularRuleGetRequest}
   * @param {CalendarRegularRuleGetRequest} fbeValue CalendarRegularRuleGetRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.RuleName.set(fbeValue.RuleName)
    this.Symbol.set(fbeValue.Symbol)
  }
}

export { FieldModelCalendarRegularRuleGetRequest };

/**
 * Fast Binary Encoding CalendarRegularRuleGetRequest model
 */
class CalendarRegularRuleGetRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelCalendarRegularRuleGetRequest(this.buffer, 4)
  }

  /**
   * Get the CalendarRegularRuleGetRequest model
   * @this {!CalendarRegularRuleGetRequestModel}
   * @returns {!FieldModelCalendarRegularRuleGetRequest} model CalendarRegularRuleGetRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!CalendarRegularRuleGetRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!CalendarRegularRuleGetRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return CalendarRegularRuleGetRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!CalendarRegularRuleGetRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelCalendarRegularRuleGetRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!CalendarRegularRuleGetRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!CalendarRegularRuleGetRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!CalendarRegularRuleGetRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!CalendarRegularRuleGetRequestModel}
   * @param {!CalendarRegularRuleGetRequest} value CalendarRegularRuleGetRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!CalendarRegularRuleGetRequestModel}
   * @param {!CalendarRegularRuleGetRequest} value CalendarRegularRuleGetRequest value, defaults is new CalendarRegularRuleGetRequest()
   * @return {!object} Deserialized CalendarRegularRuleGetRequest value and its size
   */
  deserialize (value = new CalendarRegularRuleGetRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new CalendarRegularRuleGetRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new CalendarRegularRuleGetRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!CalendarRegularRuleGetRequestModel}
   * @param {!number} prev Previous CalendarRegularRuleGetRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { CalendarRegularRuleGetRequestModel };
CalendarRegularRuleGetRequest.__has_response = true;
CalendarRegularRuleGetRequest.__response_class = CalendarRegularRuleGetResponse;
